import styled from "styled-components"
import { Modal } from "semantic-ui-react"

export const ModalContent = styled(Modal.Content)`
  display: flex;
  justify-content: center;
`
